<article>
  <table mat-table [dataSource]="screens()" class="mat-table-container">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Nom de l'écran</th>
      <td mat-cell *matCellDef="let element">
        {{ element.name }}
        <div class="mat-mdc-cell__date">
          Créer le: {{ element.createdAt | date: 'dd/MM/YYYY' }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="channel">
      <th mat-header-cell *matHeaderCellDef>Support</th>
      <td mat-cell *matCellDef="let element">
        {{ element.channel.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="mediaType">
      <th mat-header-cell *matHeaderCellDef>Type de média</th>
      <td mat-cell *matCellDef="let element">
        {{ element.mediaType | mediaType }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef
        class="mat-table-container__actions-header"
      >
        Actions
      </th>
      <td
        mat-cell
        *matCellDef="let element"
        class="mat-table-container__actions"
      >
        <button
          type="button"
          matTooltip="Modifier"
          (click)="openEditDialog(element)"
        >
          <img [lazyLoad]="'assets/icons/pen-to-square.svg'" alt="edit" />
        </button>
        <button
          type="button"
          matTooltip="Supprimer"
          (click)="openDeleteDialog(element)"
        >
          <img [lazyLoad]="'assets/icons/trash.svg'" alt="trash" />
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length">
        Aucune donnée disponible
      </td>
    </tr>
  </table>
</article>
